import { cn } from "@/lib/utils";

type LogoMarkProps = {
  size?: number;
  primary?: string;
  accent?: string;
  className?: string;
};

export function LogoMark({
  size = 32,
  primary = "var(--brand-teal)",
  accent = "var(--brand-accent)",
  className,
}: LogoMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      fill="none"
      aria-hidden="true"
      className={className}
    >
      <path d="M40 8 A32 32 0 0 0 8 40 L40 40 Z" fill={primary} />
      <path d="M40 72 A32 32 0 0 0 72 40 L40 40 Z" fill={primary} />
      <circle cx="40" cy="40" r="8" fill={accent} />
    </svg>
  );
}

type LogoProps = {
  size?: number;
  variant?: "default" | "onDark";
  showWordmark?: boolean;
  className?: string;
};

export function Logo({
  size = 32,
  variant = "default",
  showWordmark = true,
  className,
}: LogoProps) {
  const onDark = variant === "onDark";
  const markPrimary = onDark ? "var(--brand-bone)" : "var(--brand-teal)";
  const leadColor = onDark ? "var(--brand-bone)" : "var(--brand-teal)";
  const conversaColor = onDark
    ? "color-mix(in oklab, var(--brand-bone) 65%, transparent)"
    : "var(--brand-fog)";

  const wordSize = Math.round(size * 0.62);

  return (
    <span
      className={cn("inline-flex items-center gap-2", className)}
      aria-label="Lead Conversa"
    >
      <LogoMark size={size} primary={markPrimary} />
      {showWordmark && (
        <span
          className="font-display font-semibold leading-none tracking-tight whitespace-nowrap"
          style={{ fontSize: wordSize }}
        >
          <span style={{ color: leadColor }}>Lead</span>{" "}
          <span style={{ color: conversaColor, fontWeight: 400 }}>
            Conversa
          </span>
        </span>
      )}
    </span>
  );
}
